import type { AxiosRequestConfig } from 'axios'
import type { RequestOptions } from '@mp/http-axios'

import { createAxios } from './index'

// #region sdp message request start
export const defHttp = createAxios({
  requestOptions: {
    // 接口地址
    apiUrl: window.location.origin,
    // 接口拼接地址
    urlPrefix: '/mchgateway/sdpmessage',
  },
})

export function request<T>(url: string, options: AxiosRequestConfig & { customOptions?: RequestOptions }): Promise<T> {
  const { customOptions } = options || {}
  return defHttp.request({ ...options, url }, customOptions)
}
// #endregion sdp message request end
